export const footerTranslations = {
    en: {
        contact: "Contact us:",
        exploreMore: "Explore more:",
        followUs: "Follow us on:",
        dubrovnik: "- Dubrovnik by boat",
        elaphiti: "- Elaphite islands cruise"
    },
    hr: {
        contact: "Kontaktirajte nas:",
        exploreMore: "Istražite više:",
        followUs: "Pratite nas na:",
        dubrovnik: "- Dubrovnik brodom",
        elaphiti: "- Krstarenje Elafitima"
    },
    es: {
        contact: "Contáctenos:",
        exploreMore: "Explora más:",
        followUs: "Síguenos en:",
        dubrovnik: "- Dubrovnik en barco",
        elaphiti: "- Crucero islas Eláfites"
    },
    it: {
        contact: "Contattaci:",
        exploreMore: "Scopri di più:",
        followUs: "Seguici su:",
        dubrovnik: "- Dubrovnik in barca",
        elaphiti: "- Crociera isole Elafiti"
    },
    pl: {
        contact: "Skontaktuj się z nami:",
        exploreMore: "Odkryj więcej:",
        followUs: "Obserwuj nas na:",
        dubrovnik: "- Dubrownik łodzią",
        elaphiti: "- Rejs po wyspach Elafiti"
    },
    fr: {
        contact: "Contactez-nous:",
        exploreMore: "Explorez plus:",
        followUs: "Suivez-nous sur:",
        dubrovnik: "- Dubrovnik en bateau",
        elaphiti: "- Croisière îles Élaphites"
    },
    de: {
        contact: "Kontaktieren Sie uns:",
        exploreMore: "Mehr entdecken:",
        followUs: "Folgen Sie uns auf:",
        dubrovnik: "- Dubrovnik per Boot",
        elaphiti: "- Kreuzfahrt Elaphiten-Inseln"
    }
};